module.exports = __webpack_public_path__ + "img/prize-sty-dark.ac384bee.png";